import React from 'react';
import styles from './ListTab.module.css';
import moment from 'moment';
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  TableCell,
} from '@mui/material';

const CustomTableHeaderCell = styled(TableCell)(({ theme }) => ({
  padding: '16px 12px',
  fontSize: '14px',
  color: '#fff',
  background: '#073E53',
  textTransform: 'capitalize',
  fontWeight: '400',
}));
const CustomTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: '400',
  color: '#142C44',
}));

function LeadAdditionalInfoTab(props: any) {
  const { leadAdditionalDetails } = props;
  const capitalizeFirstLetter = (text: any) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  };

  const formatValue = (text: any) => {
    if (!text) return '';
    const formattedText = text.replace(/_/g, ' ');
    return formattedText.charAt(0).toUpperCase() + formattedText.slice(1);
  };

  return (
    <div className={styles.additionalInfoTabWrap}>
      <div className={styles.additionalInfoTitle}>Additional Details</div>

      {/* <div>
        <div className={styles.additionalInfoTableHead}>
          <div className={styles.additionalInfoTableHeadLeft}>Fields</div>
          <div>Response</div>
        </div>
        <div>
          {leadAdditionalDetails?.additionalInfo
            ?.filter(
              (item: any) =>
                item.fieldValue !== '' &&
                item.fieldType !== 'file' &&
                item.fieldType !== 'profilePic'
            )
            ?.map((item: any) => (
              <div className={styles.additionalInfoTableRow}>
                <div className={styles.additionalInfoTableRowLeft}>
                  {item?.fieldLabel}
                </div>
                <div>
                  {item.fieldType === 'date' ? (
                    moment(item.fieldValue).format('DD/MM/YYYY')
                  ) : item.fieldType === 'checkbox' ? (
                    Array.isArray(item.fieldValue) ? (
                      <ul className={styles.checkboxList}>
                        {item.fieldValue.map((value: any, index: number) => (
                          <li key={index}>{formatValue(value)}</li>
                        ))}
                      </ul>
                    ) : (
                      <ul className={styles.checkboxList}>
                        <li>{capitalizeFirstLetter(item.fieldValue)}</li>
                      </ul>
                    )
                  ) : item.fieldType === 'phone' ? (
                    `+${
                      item?.countryCode ? item?.countryCode : ''
                    } ${item?.fieldValue?.slice(item?.countryCode?.length)}`
                  ) : (
                    capitalizeFirstLetter(item.fieldValue)
                  )}
                </div>
              </div>
            ))}
        </div>
      </div> */}
      <div className={styles.additionalInfoTableWrap}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <CustomTableHeaderCell>Fields</CustomTableHeaderCell>
                <CustomTableHeaderCell>Response</CustomTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leadAdditionalDetails?.additionalInfo
                ?.filter(
                  (item: any) =>
                    item.fieldValue !== '' &&
                    item.fieldType !== 'file' &&
                    item.fieldType !== 'profilePic'
                )
                ?.map((item: any, idx: number) => (
                  <TableRow key={idx}>
                    <CustomTableCell
                      sx={{ textTransform: 'capitalize', fontWeight: '500' }}
                    >
                      {item?.fieldLabel}
                    </CustomTableCell>
                    <CustomTableCell>
                      {item.fieldType === 'date' ? (
                        moment(item.fieldValue).format('DD/MM/YYYY')
                      ) : item.fieldType === 'checkbox' ? (
                        Array.isArray(item.fieldValue) ? (
                          <ul className={styles.checkboxList}>
                            {item.fieldValue.map(
                              (value: any, index: number) => (
                                <li key={index}>{formatValue(value)}</li>
                              )
                            )}
                          </ul>
                        ) : (
                          <ul className={styles.checkboxList}>
                            <li>{capitalizeFirstLetter(item.fieldValue)}</li>
                          </ul>
                        )
                      ) : item.fieldType === 'phone' ? (
                        `+${item?.countryCode || ''} ${item?.fieldValue?.slice(
                          item?.countryCode?.length
                        )}`
                      ) : (
                        capitalizeFirstLetter(item.fieldValue)
                      )}
                    </CustomTableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default LeadAdditionalInfoTab;
